import styled from 'styled-components';
export var Dot = styled.div.withConfig({
  displayName: "Dot",
  componentId: "sc-j0f8mu-0"
})(["display:inline-block;width:11px;height:11px;border-radius:100%;margin:2px;cursor:pointer;background-color:", ";transition:background-color 200ms linear;&:hover{background-color:", ";}"], function (_ref) {
  var active = _ref.active,
    theme = _ref.theme;
  return active ? theme.colors.primary : theme.colors.terciaryM;
}, function (_ref2) {
  var active = _ref2.active,
    theme = _ref2.theme;
  return active ? theme.colors.primary : theme.colors.primaryL;
});